import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { textColor } from '../../styles/basics/colors';

import { BOLINDA_ICONS, MATERIAL_ICONS } from './Button/Icon';
import { LocationDescriptor } from 'history';

const StLink = styled(Link)`
    display: inline-flex;
    align-items: center;
`;

const StLabel = styled.span`
    font-size: inherit;
    line-height: 1 !important;
`;

const StIcon = styled.i<{ readonly color?: string }>`
    ${props => (props.color ? textColor(props.color) : '')};
    font-size: inherit;
    line-height: 1 !important;

    + ${StLabel} {
        margin-right: 0.3em;
    }
`;

type Props = {
    readonly to: LocationDescriptor;
    readonly icon: string;
    readonly label: string;
    readonly iconColor?: string;
    readonly className?: string;
};

const LinkWithIconRight: FC<Props> = props => {
    let iconClassName: string | undefined = undefined;
    if (BOLINDA_ICONS.indexOf(props.icon) >= 0) {
        iconClassName = 'bolinda-icons';
    } else if (MATERIAL_ICONS.indexOf(props.icon) >= 0) {
        iconClassName = 'material-icons';
    }

    return (
        <StLink to={props.to} className={props.className}>
            <StLabel>{props.label}</StLabel>
            <StIcon color={props.iconColor} className={iconClassName}>
                {props.icon}
            </StIcon>
        </StLink>
    );
};

export default LinkWithIconRight;
